import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback } from 'react';
import { PaddingBox } from '../../../../components/PaddingBox/index';
import {
	selectIsVisibleMobileHeaderSearch,
	toggleMobileHeaderSearch as toggleMobileHeaderSearchAction,
} from '../../../app/store/index';
import { Search } from '../../../../components/Icons/Search';
import { IconButton } from '../../../../components/IconButton/index';

export const ListFilterListSearchButton = ({ disabled }: { disabled?: boolean }) => {
	const dispatch = useDispatch();
	const toggleMobileHeaderSearch = useCallback(() => dispatch(toggleMobileHeaderSearchAction()), [dispatch]);
	const isVisibleMobileHeaderSearch: boolean = useSelector(selectIsVisibleMobileHeaderSearch);

	return (
		<PaddingBox rightSmall>
			<IconButton
				link
				onClick={toggleMobileHeaderSearch}
				active={isVisibleMobileHeaderSearch}
				disabled={disabled}
			>
				<Search />
			</IconButton>
		</PaddingBox>
	);
};
